export default "<p>\n  photo-field works!\n</p>\n"